import React from 'react'

const NotFound = () => {
    return (
        <div>
            <h2>Sorry! - Page Not Found</h2>
        </div>
    )
}

export default NotFound
